import { ArrowRight } from "lucide-react";
import { useBookingDialog } from "@/contexts/BookingDialogContext";

export default function CTASection() {
  const { openDialog } = useBookingDialog();

  return (
    <section
      id="book"
      data-testid="cta-section"
      className="relative py-28 sm:py-40 bg-[#0D3A35] text-white grain overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#B1B7AB] blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#276152] blur-3xl" />
      </div>

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-xs uppercase tracking-[0.22em] text-[#B1B7AB] font-semibold">
          Book a consultation
        </p>
        <h2 className="font-serif text-5xl sm:text-7xl leading-[0.95] mt-5">
          Ready to see <br />
          your venue,{" "}
          <span className="text-[#B1B7AB]">filmed beautifully</span>?
        </h2>
        <p className="mt-7 text-lg text-white/80 max-w-xl mx-auto">
          Share a few details about your brand &mdash; country, business type,
          dates &mdash; and we&apos;ll match you with the right creators and
          contract.
        </p>

        <div className="mt-10 flex items-center justify-center">
          <button
            type="button"
            data-testid="cta-book-consultation"
            onClick={() => openDialog()}
            className="inline-flex items-center gap-2 h-12 px-8 rounded-full bg-white text-[#0D3A35] text-sm font-semibold hover:bg-[#B1B7AB] transition-colors"
          >
            Book consultation
            <ArrowRight className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>
      </div>
    </section>
  );
}
